import AddToCart from './AddToCart';
export default AddToCart;